import React from "react";
import PropTypes from "prop-types";

export const Navigation = (props) => {
  const {children} = props;
  return <nav>{children}</nav>;
};

Navigation.propTypes = {
  children: PropTypes.node,
  isFullscreen: PropTypes.bool,
  isModal: PropTypes.bool,
  getStyles: PropTypes.func
};

export default Navigation;
